export const SCHEMA_CONFIG = {
	CVReview_1004: {
		schema: 'CVReview:1',
		formType: '1004',
	},

	CVReview_1073: {
		schema: 'CVReview1073:1',
		formType: '1073',
	},

	CVReview_1075: {
		schema: 'CVReview1075:1',
		formType: '1075',
	},

	CVReview_2055: {
		schema: 'CVReview2055:1',
		formType: '2055',
	},

	InspectionReport: {
		schema: 'InspectionReport:3',
		formType: 'FREDDIE',
	},

	CVReviewAltVal: {
		schema: 'CVReviewAltVal',
		formType: 'FORMSET-CV',
	},

	CV_CLASSUAD2: {
		schema: '3.6GSE:1',
		formType: 'CLASSUAD2',
	},

	PDF_SCHEMA: {
		schema: 'CVReviewPDF:1',
		formType: 'Generic-PDF',
	},

	CVReview1004D: {
		schema: 'CVReview1004D:1',
		formType: '1004D',
	},

	CVReview1004C: {
		schema: 'CVReview1004C:1',
		formType: '1004C',
	},
	FNMA: {
		schema: '',
		formType: 'FNMA'
	},
	CVReview1025: {
		schema: 'CVReview1025:1',
		formType: '1025'
	},
	CVReviewBPOExtJPM: {
		schema: 'CVReviewBPOExtJPM:1',
		formType: 'FORMSET-BPO-EXT-V2021'
	},
	CVReview2090: {
		schema: 'CVReview2090:1',
		formType: '2090'
	},
	CVReview2075: {
		schema: 'CVReview2075:1',
		formType: '2075'
	}
}

export const SIMPLIFIED_NAV_SCHEMA_SET = new Set<string>([
	SCHEMA_CONFIG.CVReviewAltVal.schema,
	SCHEMA_CONFIG.CV_CLASSUAD2.schema,
	SCHEMA_CONFIG.PDF_SCHEMA.schema,
	SCHEMA_CONFIG.CVReview1004D.schema,
	SCHEMA_CONFIG.CVReview1004C.schema,
	SCHEMA_CONFIG.CVReview1025.schema,
	SCHEMA_CONFIG.CVReviewBPOExtJPM.schema,
	SCHEMA_CONFIG.CVReview2090.schema,
	SCHEMA_CONFIG.CVReview2075.schema
]);

export const SIMPLIFIED_NAV_FORMS_SET = new Set<string>([
	SCHEMA_CONFIG.CVReviewAltVal.formType,
	SCHEMA_CONFIG.CV_CLASSUAD2.formType,
	SCHEMA_CONFIG.PDF_SCHEMA.formType,
	SCHEMA_CONFIG.CVReview1004D.formType,
	SCHEMA_CONFIG.CVReview1004C.formType,
	SCHEMA_CONFIG.CVReview1025.formType,
	SCHEMA_CONFIG.CVReviewBPOExtJPM.formType,
	SCHEMA_CONFIG.CVReview2090.formType,
	SCHEMA_CONFIG.CVReview2075.formType
]);



